import { schema } from 'normalizr'

export const apartment = new schema.Entity('apartments', {}, { idAttribute: 'remoteApartmentsId' })
export const arrayOfApartments = new schema.Array(apartment)



// WEBPACK FOOTER //
// ./src/adapters/dobovoApartmentsSchema.js